// Single Express + MySQL backend now, so there's just one base URL.
// Reads REACT_APP_API_BASE_URL if set (e.g. from a local .env.local file
// for testing against your local backend), otherwise falls back to the
// live production subdomain.
//
// Local testing: create a .env.local at your project root (same folder
// as package.json) with:
//   REACT_APP_API_BASE_URL=http://localhost:5000/api
// then restart `npm start` (Create React App only reads env files on
// startup, so changes require a restart, not just a save).
export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://api.sareauctioneers.co.ke/api";

// Kept for backward compatibility with older imports.
export const AUTH_API_BASE_URL = API_BASE_URL;
export const USR_API_BASE_URL = API_BASE_URL;